import React from "react";
import { useDisclosure, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { SetOrderListingColumnsConfigDialog } from "./SetOrderListingColumnsConfigDialog";

export interface SetOrderListingColumnsConfigButtonProps {
    pageSize: number;
    setPageSize(pageSize: number): void;
}

export const SetOrderListingColumnsConfigButton: React.VFC<SetOrderListingColumnsConfigButtonProps> = (
    props: SetOrderListingColumnsConfigButtonProps
) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdRead]}>
            <CommandBarButton icon={"Settings"} onClick={onOpen} text={`Config`} />
            {isOpen && (
                <SetOrderListingColumnsConfigDialog
                    key={String(isOpen)}
                    isOpen={isOpen}
                    onClose={onClose}
                    pageSize={props.pageSize}
                    setPageSize={props.setPageSize}
                />
            )}
        </AuthorizationWrapper>
    );
};
